import { PropTypes } from "prop-types";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { branches } from "../../constants/enums";

const propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const branchesMenuItem = Object.entries(branches).map(([enumVal, display]) => {
  return (
    <MenuItem key={enumVal} value={enumVal}>
      {display}
    </MenuItem>
  );
});

const ServiceBranchDropdown = ({ value, onChange }) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="branch-label">Service Branch</InputLabel>
      <Select
        labelId="branch-selection"
        id="branch-select"
        value={value}
        label="Service Branch"
        onChange={onChange}
      >
        {branchesMenuItem}
      </Select>
    </FormControl>
  );
};

ServiceBranchDropdown.propTypes = propTypes;

export default ServiceBranchDropdown;
